import { Component, Prop, Vue } from 'vue-property-decorator';
import IconText from '../shared/iconText.vue';

@Component({ components: { IconText } })
export default class LinkToAdder extends Vue {
  @Prop() private suggestionsListId!: string;
  @Prop() private modality!: string;
  @Prop() private label!: string;
  @Prop() private description!: string;
  @Prop() private query!: any;
  @Prop() private icon!: string;
}
